import React, {useEffect, useState} from 'react';
import Switch from "../../../forms/inputs/Switch";

const AssignProducts = (props) => {
    const {
        installationId          = null,
        job                     = null,
        hasOverriddenProducts   = false,
        availableProducts       = [],
        productIds              = [],
        onChange                = (productIds) => {},
        disabled                = false,
        errors                  = null,
    } = props;

    const [overrideProducts, setOverrideProducts] = useState(hasOverriddenProducts);

    useEffect(() => {
        setOverrideProducts(hasOverriddenProducts);
    }, [hasOverriddenProducts]);

    useEffect(() => {
        if (overrideProducts === false) {
            handleOverrideToggle();
        }
    }, [overrideProducts]);

    const overrideEnabled = () => {
        return (overrideProducts && !!job && !!job.products && !!job.products.length > 0);
    }

    const getFilteredProducts = () => {
        let productsToFilter = availableProducts;

        if (overrideEnabled()) {
            productsToFilter = job.products;
        }

        return productsToFilter.filter((product) => {
            if (!product.installation_id) {
                return true;
            }

            if (!installationId && !!product.installation_id) {
                return false;
            }

            if (!!installationId && !!product.installation_id) {
                return (parseInt(product.installation_id) === parseInt(installationId));
            }

            return true;
        });
    }

    let filteredProducts = getFilteredProducts();

    const getSelectAllValue = () => {
        return productIds.length > 0 && filteredProducts.length === productIds.length;
    }

    const handleSelectAll = () => {
        const newProductIds = [];

        for (let i = 0; i < filteredProducts.length; i++) {
            newProductIds.push(filteredProducts[i].id);
        }

        onChange(newProductIds);
    }

    const handleDeselectAll = () => {
        onChange([]);
    }

    const handleSelect = (product) => {
        const clone = _.cloneDeep(productIds);

        if (!clone.includes(product.id)) {
            clone.push(product.id);

            onChange(clone);
        }
    }

    const handleDeselect = (product) => {
        const clone = _.cloneDeep(productIds);

        if (clone.includes(product.id)) {
            let index = null;
            for (let i = 0; i < clone.length; i++) {
                if (clone[i] === product.id) {
                    index = i;
                }
            }

            clone.splice(index, 1);

            onChange([...clone]);
        }
    }

    const handleOverrideToggle = () => {
        const newProductIds = [];

        for (let i = 0; i < filteredProducts.length; i++) {
            if (productIds.includes(filteredProducts[i].id)) {
                newProductIds.push(filteredProducts[i].id);
            }
        }

        onChange(newProductIds);
    }

    const renderNoItems = () => {
        return (
            <div className={"product-row empty"}>
                <span>No Products</span>
            </div>
        )
    }

    const renderLineItemRow = (index, product) => {
        let productDisabled = false;

        if (!!product.installation_id) {
            productDisabled = !(!!installationId && (parseInt(installationId) === parseInt(product.installation_id)));
        }

        return (
            <div className={productDisabled ? "product-row disabled" : "product-row"} key={product.id}>
                <div className="column checkbox-column">
                    <input
                        type="checkbox"
                        checked={productIds.includes(product.id)}
                        disabled={productDisabled || disabled}
                        onChange={() => productIds.includes(product.id) ? handleDeselect(product) : handleSelect(product)}
                    />
                </div>
                <div className="column name-column">
                    <p className={"m-0"}>{product.name}</p>
                </div>
                <div className="column quantity-column">
                    <p className={"m-0"}>{product.quantity}</p>
                </div>
                <div className="column price-column">
                    <p className={"m-0"}>{product.price}</p>
                </div>
            </div>
        );
    }

    const selectAll = getSelectAllValue();

    let productsForRow = availableProducts;
    if (overrideEnabled()) {
        productsForRow = job.products;
    }

    return (
        <React.Fragment>
            <div className={"m-0 mb-4 quote-products-table"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                    <div className={"h5 mb-0 text-eh-navy"}>
                        Select Products
                    </div>
                    <div>
                        <Switch
                            name={"override_products"}
                            rightLabel={null}
                            leftLabel={"Override Products"}
                            value={overrideProducts}
                            checked={overrideProducts}
                            onChange={() => setOverrideProducts(!overrideProducts)}
                            disabled={!job || !job.products}
                        />
                    </div>
                </div>
                {!!errors && !!errors.product_ids && (
                    <div className="invalid-feedback d-block mt-0 mb-3" role="alert">
                        <strong>
                            {errors.product_ids}
                        </strong>
                    </div>
                )}
                <div className={"product-table mb-3"}>
                    <div className="header">
                        <div className="column checkbox-column">
                            <input
                                type="checkbox"
                                checked={selectAll}
                                disabled={disabled}
                                onChange={(event) => selectAll ? handleDeselectAll(event) : handleSelectAll(event)}
                            />
                        </div>
                        <div className="column name-column">
                            <span>Product name</span>
                        </div>
                        <div className="column quantity-column">
                            <span>Quantity</span>
                        </div>
                        <div className="column price-column">
                            <span>Price</span>
                        </div>
                    </div>
                    {!!productsForRow && productsForRow.length > 0 ? productsForRow.map((product, index) => renderLineItemRow(index, product)) : renderNoItems()}
                </div>
            </div>
        </React.Fragment>
    );
}

export default AssignProducts;
